import React from 'react'
import v1 from '../photo_video/workout1.mp4'
import v2 from '../photo_video/workout2.mp4'

function
    Advice() {
    return (
        <div className='Onlineclub' id='workout'>
            <div className='d-flex justify-content-center mt-4 '>
                <div className='mb-5 position-relative'><h2 className='pageHeader'>Live Workout (Online)</h2></div>
            </div>
            <div  className='d-flex justify-content-center flex-wrap'>
                <div className=' p-4'>
                    <video muted controls autoPlay loop style={{ maxWidth: '100%', borderRadius: '20px' }}>
                        <source src={v1} type="video/mp4" />
                    </video>
                </div>
                <div className=' p-4'>
                    <video muted controls autoPlay loop style={{ maxWidth: '100%', borderRadius: '20px' }}>
                        <source src={v2} type="video/mp4" />
                    </video>
                </div>
            </div>
        </div>
    )
}

export default
    Advice
